import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=e2d96490&scoped=true"
import script from "./HomeProfile.vue?vue&type=script&lang=js"
export * from "./HomeProfile.vue?vue&type=script&lang=js"
import style0 from "./HomeProfile.vue?vue&type=style&index=0&id=e2d96490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d96490",
  null
  
)

export default component.exports